// ============================================================
// AUTH SERVICE
// ============================================================

import { AUTH_TOKEN_KEY, AUTH_USER_KEY, API_BASE_URL } from '../utils/constants';

export const authService = {
  login: async (username, password) => {
    const url = `${API_BASE_URL}/admin/auth/login`;
    console.log('[authService] Attempting login to:', url);
    
    try {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      
      let json;
      try {
        json = await res.json();
      } catch (parseError) {
        console.error('[authService] Failed to parse response:', parseError);
        throw new Error('Server error. Please try again.');
      }
      
      console.log('[authService] Response:', { status: res.status, success: json.success });
      
      if (!res.ok) {
        throw new Error(json.message || json.error || 'Invalid credentials');
      }
      
      const data = json.data || json;
      const token = data.access_token || data.token;
      const user = data.user;
      
      if (!token) {
        console.error('[authService] No token in response:', data);
        throw new Error('Login failed. Please try again.');
      }
      
      localStorage.setItem(AUTH_TOKEN_KEY, token);
      localStorage.setItem(AUTH_USER_KEY, JSON.stringify(user));
      console.log('[authService] Login successful for user:', user.username);
      
      return { success: true, token, user };
    } catch (error) {
      console.error('[authService] Login error:', error);
      throw error;
    }
  },

  logout: () => {
    localStorage.removeItem(AUTH_TOKEN_KEY);
    localStorage.removeItem(AUTH_USER_KEY);
  },

  getToken: () => localStorage.getItem(AUTH_TOKEN_KEY),

  getUser: () => {
    try {
      const u = localStorage.getItem(AUTH_USER_KEY);
      return u ? JSON.parse(u) : null;
    } catch { return null; }
  },

  isAuthenticated: () => {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    const user = localStorage.getItem(AUTH_USER_KEY);
    return !!(token && user);
  },
};

